<template>
    <div class="k-btn-icon-group">
        <v-list class="widgets-group-flex" color="#f0f0f0">
            <v-list-item v-for="item in items" :key="item.type" :value="item.type"
                :class="{ selected: modelValue === item.type }" class="widget-item-btn" @click="selectItem(item)">
                <div :class="`icon-box bg-icon-${color} `" v-html="item.icon"></div>
                <p>{{ item.title }}</p>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
export default {
    name: "BtnIconGroup",
    props: {
        modelValue: [String, Number],
        items: {
            type: Array,
            required: true,
        },
        mandatory: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: "blue",
        },
    },
    methods: {
        selectItem(item) {
            this.$emit("update:modelValue", item.type);
        },
    },
};
</script>

<style>
.widgets-group-flex {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .widget-item-btn {
        padding: 8px !important;
        background: transparent;
        border-radius: 12px;
        text-align: center;
        width: 25%;

        &.selected {
            background: #f0f0f0;
        }

        .icon-box {
            position: relative;
            width: 40px;
            height: 40px;
            border-radius: 8px;
            padding: 4px;
            text-align: center;
            margin: 0px auto 4px;

            svg {
                stroke-width: 1.5px;
                fill: #fff;
                border-radius: 0px;
                width: 70%;
                height: 100%;
                transform: rotate(0deg);
                transition: transform 0.15s;
                display: flex;
                margin: auto;
                align-items: center;
            }
        }

        p {
            font-size: 12px;
            text-align: center;
        }
    }

    .v-col-md-3 {
        padding: 0px !important;
    }
}
</style>
